import React, { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import TunnelResultPage from '@/components/TunnelResultPage/TunnelResultPage';
import { ROUTE } from '@/constants/route';
import { useAuth } from '@/hooks/useAuth';
import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';

export const FaireVersementError: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { state } = useLocation();
  const idPlacement = state?.idPlacement;

  useEffect(() => {
    if (user?.id && user.type && user.success) {
      TRACKING_INSTANCE.setTcVars({
        page_nom: 'erreur versement',
        page_template: 'espace client',
        user_id: user.id,
        user_client: user.type === 'Client',
        user_connexion: user.success,
        user_statut_contrat: sessionStorage.getItem('user_statut_contrat'),
        tunnel_produit: JSON.parse(sessionStorage.getItem('parcoursVersementData') || '{}').contratNomProduit,
        tunnel_metier: 'espace client placement',
        tunnel_sous_metier: JSON.parse(sessionStorage.getItem('parcoursVersementData') || '{}').contratFamille,
        tunnel_categorie_produit: 'parcours de versement',
      });
      void TRACKING_INSTANCE.triggerEvent('page', undefined, {
        event_id: 'page',
        event_categorie: 'affichage espace client',
        event_nom: 'erreur versement',
        event_page: 'erreur versement',
      });
    }
  }, [user?.id, user?.type, user?.success]);

  return (
    <TunnelResultPage
      iconName="warning-solide"
      iconVariant="error"
      title={t('faireVersementError.title')}
      subtitles={[t('faireVersementError.subtitle1'), t('faireVersementError.subtitle2')]}
      ctaLabel={t('faireVersementError.cta')}
      onCtaClick={() => navigate(ROUTE.SELECTCONTRACT, { state: { key: 'versement', retry: true, idPlacement } })}
    />
  );
};
